import { render, staticRenderFns } from "./hospital-logistics-evaluation.vue?vue&type=template&id=6d8443ff&scoped=true&"
import script from "./hospital-logistics-evaluation.vue?vue&type=script&lang=js&"
export * from "./hospital-logistics-evaluation.vue?vue&type=script&lang=js&"
import style0 from "./hospital-logistics-evaluation.vue?vue&type=style&index=0&id=6d8443ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8443ff",
  null
  
)

export default component.exports